import React from "react";
import { PaziaButton } from "components/atoms";
import { EmailTemplateApi } from "api/emailtemplates/emailtemplatesApi";

interface TemplatePreviewModalProps {
  template: EmailTemplateApi | null;
  isOpen: boolean;
  onClose: () => void;
  onLoad?: (template: EmailTemplateApi) => void;
}

export const TemplatePreviewModal: React.FC<TemplatePreviewModalProps> = ({ template, isOpen, onClose, onLoad }) => {
  if (!isOpen || !template) return null;

  const handleLoad = () => {
    if (onLoad && template) {
      onLoad(template);
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="max-h-[90vh] w-full max-w-4xl overflow-hidden rounded-lg bg-white shadow-xl dark:bg-slate-800">
        {/* Header */}
        <div className="flex items-center justify-between border-b px-6 py-4">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-slate-200">Podgląd szablonu: {template.name}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="max-h-[60vh] overflow-y-auto p-6">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 dark:text-slate-300">Temat:</label>
            <p className="mt-1 text-gray-900 dark:text-slate-100">{template.subject}</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-slate-300">Treść:</label>
            <div
              className="mt-1 max-h-96 overflow-y-auto rounded border bg-gray-50 p-4 dark:bg-slate-900/40"
              dangerouslySetInnerHTML={{ __html: template.htmlBody }}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 border-t px-6 py-4">
          <PaziaButton btnType="button" type="tertiary" onClick={onClose}>
            Zamknij
          </PaziaButton>
          {onLoad && (
            <PaziaButton btnType="button" type="primary" onClick={handleLoad}>
              Załaduj szablon
            </PaziaButton>
          )}
        </div>
      </div>
    </div>
  );
};
